// extracted by mini-css-extract-plugin
export default {"quote":"Quote_quote__47Juy"};